import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useUpdatePortalRefund from "@babackapp/private-api-client/client/use-update-shop-refund";
import PortalRefundForm from "./portal-refund-form";

import { z } from "zod";

export const PortalRefundFormSchema = z.object({
  tagsForNotAcceptedRefund: z.array(z.string()),
});

export type PortalRefundFormValues = z.infer<typeof PortalRefundFormSchema>;

export default function PortalRefundCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: updatePortalRefund } = useUpdatePortalRefund(shop);

  const onSubmit = (values: PortalRefundFormValues) => {
    return updatePortalRefund(values);
  };

  return (
    <Card className="w-full">
      <CardContent>
        <PortalRefundForm
          onSubmit={onSubmit}
          defaultValues={{
            tagsForNotAcceptedRefund: shop.refund.tagsForNotAcceptedRefund,
          }}
        />
      </CardContent>
    </Card>
  );
}
